// Icon-only copy-to-clipboard button for narrow, ellipsis-truncated table
// cells where a full inline value can't fit (see item 140 Phase B). Mirrors
// the Copy/Check affordance used in Tokens.tsx's snippet copy buttons.

import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '../../lib/cn';

export function CopyIconButton({ value, label, className }: {
  value: string;
  label?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard write can fail in non-secure contexts; nothing to fall
      // back to here since the full value is already behind ellipsis.
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      title={copied ? 'Copied' : (label ?? 'Copy full value')}
      className={cn(
        'inline-flex items-center justify-center h-5 w-5 shrink-0 rounded text-fg-muted hover:text-fg hover:bg-bg-hover',
        className,
      )}
    >
      {copied ? <Check className="h-3 w-3 text-success" /> : <Copy className="h-3 w-3" />}
    </button>
  );
}
